const NotificationIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2109_25557)"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_2109_25557)">
        <path
          d="M22.3863 18.6474C22.3287 18.5786 22.2721 18.5097 22.2166 18.4433C21.4534 17.5273 20.9916 16.9744 20.9916 14.3814C20.9916 13.0389 20.6679 11.9373 20.0299 11.1112C19.5595 10.5008 18.9236 10.0378 18.0854 9.69568C18.0746 9.68973 18.065 9.68192 18.057 9.67262C17.7555 8.67091 16.9305 8 16 8C15.0695 8 14.2449 8.67091 13.9434 9.67159C13.9354 9.68054 13.9259 9.68811 13.9153 9.69396C11.9593 10.4929 11.0087 12.0258 11.0087 14.3803C11.0087 16.9744 10.5477 17.5273 9.78372 18.4422C9.72821 18.5087 9.67166 18.5762 9.61407 18.6464C9.46531 18.8244 9.37106 19.041 9.34247 19.2705C9.31388 19.5 9.35215 19.7328 9.45275 19.9414C9.66681 20.3889 10.123 20.6667 10.6438 20.6667H21.3601C21.8784 20.6667 22.3315 20.3892 22.5462 19.9438C22.6473 19.7351 22.6859 19.5021 22.6575 19.2724C22.6292 19.0426 22.5351 18.8257 22.3863 18.6474Z"
          fill="#052351"
        />
        <path
          d="M15.9997 24C16.5432 23.9995 17.0765 23.8361 17.5429 23.527C18.0094 23.218 18.3916 22.7748 18.6491 22.2446C18.6613 22.2192 18.6673 22.1907 18.6665 22.162C18.6658 22.1333 18.6584 22.1052 18.645 22.0806C18.6316 22.056 18.6127 22.0356 18.59 22.0215C18.5674 22.0074 18.5419 22 18.516 22H13.4842C13.4582 21.9999 13.4327 22.0073 13.41 22.0213C13.3874 22.0354 13.3684 22.0558 13.355 22.0804C13.3415 22.105 13.3341 22.1331 13.3333 22.1619C13.3326 22.1906 13.3386 22.2191 13.3507 22.2446C13.6082 22.7748 13.9904 23.2179 14.4567 23.5269C14.9231 23.836 15.4563 23.9994 15.9997 24Z"
          fill="#052351"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2109_25557"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0062FF" />
          <stop offset="1" stopColor="#004BC2" />
        </linearGradient>
        <clipPath id="clip0_2109_25557">
          <rect width="16" height="16" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NotificationIconMenu
